import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Container } from '@chakra-ui/layout';
import Footer from './footer/footer';
export var HubLayout = function HubLayout(props) {
  return /*#__PURE__*/_jsxs(Container, {
    maxW: "5xl",
    children: [props.children, /*#__PURE__*/_jsx(Footer, {
      copyrightLabel: 'Powered by Articali'
    })]
  });
};
export default HubLayout;